module.exports = __webpack_public_path__ + "static/imagem_1-56a85f62a8a3f8a9d27783bffd91bd54.jpeg";